<template>
  <v-carousel v-model="currentSlide" height="auto" cycle prev-icon="mdi-chevron-left"
    next-icon="mdi-chevron-right" hide-delimiter-background class="featured-carousel">

    <!-- Grouped slides -->
    <v-carousel-item v-for="(group, index) in groupedCruises" :key="index">
      <div class="carousel-slide-inner">
        <v-row justify="center" align="stretch">
          <v-col v-for="cruise in group" :key="cruise.id" :cols="12" :md="12 / itemsPerGroup" class="mb-4">
            <CruiseCardHome :cruise="cruise" />
          </v-col>
        </v-row>
      </div>
    </v-carousel-item>

  </v-carousel>
</template>

<script>
import CruiseCardHome from './CruiseCardHome.vue';

export default {
  name: 'FeaturedCruiseCarousel',
  components: {
    CruiseCardHome
  },
  props: {
    cruises: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      itemsPerGroup: 3,
      currentSlide: 0
    };
  },
  computed: {
    groupedCruises() {
      const groups = [];
      for (let i = 0; i < this.cruises.length; i += this.itemsPerGroup) {
        groups.push(this.cruises.slice(i, i + this.itemsPerGroup));
      }
      return groups;
    }
  },
  mounted() {
    this.updateItemsPerGroup();
    window.addEventListener('resize', this.updateItemsPerGroup);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateItemsPerGroup);
  },
  methods: {
    updateItemsPerGroup() {
      const width = window.innerWidth;
      if (width < 992) {
        this.itemsPerGroup = 1;
      } else if (width < 1400) {
        this.itemsPerGroup = 2;
      } else {
        this.itemsPerGroup = 3;
      }
    }
  }
};
</script>


<style scoped>
.featured-carousel {
  padding: 0 32px;
}

.v-carousel-item {
  padding-top: 16px;
  padding-bottom: 16px;
}

.carousel-slide-inner {
  padding-left: 100px;
  padding-right: 100px;
}

</style>